var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import ModifyConfig from "~/components/system-manage/strategy-config/modify-config.vue";
import { LabelingStrategyService } from "~/services/dataimp-service/labeling-strategy-service";
import AddQueue from "~/components/labeling-strategy/add-queue.vue";
import RunningRecordSummary from "~/components/labeling-strategy/running-record-summary.vue";
var LabelingStrategy = /** @class */ (function (_super) {
    __extends(LabelingStrategy, _super);
    function LabelingStrategy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectionList = [];
        _this.modifyData = {};
        _this.openData = "";
        _this.id = "";
        // 数据列表
        _this.dataSet = [];
        // 当前行数据
        _this.rowData = null;
        _this.importLoading = false;
        // 弹框控制
        _this.dialog = {
            config: false,
            record: false
        };
        _this.show = false;
        _this.showData = "";
        _this.labelInfo = {
            name: "",
            id: ""
        };
        _this.model = {
            labelName: "",
            labelStatus: "",
            checkTime: [] // 开始时间
        };
        return _this;
    }
    LabelingStrategy.prototype.refreshData = function () {
        var _this = this;
        this.labelingStrategyService
            .queryStrategyConfigPage(this.model, this.pageService)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    LabelingStrategy.prototype.mounted = function () {
        this.refreshData();
    };
    // 执行记录
    LabelingStrategy.prototype.executionRecordClick = function (scope) {
        this.labelInfo.name = scope.row.labelName;
        this.labelInfo.id = scope.row.id;
        this.dialog.record = true;
    };
    LabelingStrategy.prototype.onSuccess = function () {
        var _this = this;
        this.$nextTick(function () { return (_this.id = ""); });
        this.refreshData();
    };
    /**
     * 新增点击
     */
    LabelingStrategy.prototype.addClick = function () {
        this.modifyData = {};
        this.openData = 1;
        this.showData = false;
        this.show = true;
        this.dialog.config = true;
    };
    /**
     * 手动执行
     */
    LabelingStrategy.prototype.manualExecutionclick = function () {
        var _this = this;
        // if(this.selectionList.length===0){
        //   this.$message.warning('请先选择需要手动执行的催收队列！')
        //   return;
        // }else{
        // const ids:any=this.selectionList.map(v=>v.id)
        this.labelingStrategyService.manualLabel().subscribe(function (data) {
            _this.importLoading = true;
            setTimeout(function () {
                _this.$message.success("操作成功！");
                _this.refreshData();
                _this.importLoading = false;
            }, 5000);
            //   }
            // )
            // }
        });
    };
    /**
     * 修改点击
     */
    LabelingStrategy.prototype.modifyClick = function (scope) {
        this.openData = 2;
        this.modifyData = scope.row;
        this.show = false;
        this.showData = false;
        this.dialog.config = true;
    };
    __decorate([
        Dependencies(LabelingStrategyService)
    ], LabelingStrategy.prototype, "labelingStrategyService", void 0);
    __decorate([
        Dependencies(PageService)
    ], LabelingStrategy.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], LabelingStrategy.prototype, "sortService", void 0);
    LabelingStrategy = __decorate([
        Auth(2306),
        Layout("workspace"),
        Component({
            components: {
                ModifyConfig: ModifyConfig,
                AddQueue: AddQueue,
                RunningRecordSummary: RunningRecordSummary
            }
        })
    ], LabelingStrategy);
    return LabelingStrategy;
}(Vue));
export default LabelingStrategy;
